import { render, staticRenderFns } from "./KimsaRpeSlider.vue?vue&type=template&id=68a0f64a&scoped=true"
import script from "./KimsaRpeSlider.vue?vue&type=script&lang=js"
export * from "./KimsaRpeSlider.vue?vue&type=script&lang=js"
import style0 from "./KimsaRpeSlider.vue?vue&type=style&index=0&id=68a0f64a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a0f64a",
  null
  
)

export default component.exports